import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnumTipoMensagem } from '../../enum/enum-infra';

@Component({
  selector: 'app-dialog-custom',
  templateUrl: './dialog-custom.component.html',
  styleUrls: ['./dialog-custom.component.scss']
})
export class DialogCustomComponent {

  constructor(
      public dialogRef: MatDialogRef<DialogCustomComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    onCancel(): void {

      // observable execution
      if(this.data.observer){
        this.data.observer.next(false);
        this.data.observer.complete();
        this.data.observer.unsubscribe();
      }

      if(this.data.callBackCancel){
        this.data.callBackCancel();
      }

      this.dialogRef.close();
    }

    onConfirm(): void {
      if(this.data.observer){
        this.data.observer.next(true);
        this.data.observer.complete();
        this.data.observer.unsubscribe();
      }


      if(this.data.callBackConfirm){
        this.data.callBackConfirm();
      }

      this.dialogRef.close();
  }

  getClassBody(enumType: EnumTipoMensagem): string {

    let className = '';

    switch (enumType) {

      case EnumTipoMensagem.Sucesso:
        className = 'dialog-success';
        break;

      case EnumTipoMensagem.Erro:
        className = 'dialog-error';
          break;

      case EnumTipoMensagem.Alerta:
        className = 'dialog-alert';
        break;

      case EnumTipoMensagem.Info:
      case EnumTipoMensagem.Indefinido:
        default:
          className = 'dialog-info';
        break;

    }

    return  className;
  }

  getIcon(enumType: EnumTipoMensagem): string{

    let iconName = '';

    switch (enumType) {

      case EnumTipoMensagem.Sucesso:
        iconName = 'check';
        break;

      case EnumTipoMensagem.Erro:
        iconName = 'highlight_off';
          break;

      case EnumTipoMensagem.Alerta:
        iconName = 'error_outline';
        break;

      case EnumTipoMensagem.Info:
      case EnumTipoMensagem.Indefinido:
        default:
        iconName = 'info_outline';
        break;

    }
    return iconName;

  }

  getType(enumType: EnumTipoMensagem): string{

    let typeName = '';

    switch (enumType) {
      case EnumTipoMensagem.Sucesso:
        typeName = 'Sucesso';
        break;

      case EnumTipoMensagem.Erro:
        typeName = 'Erro';
          break;

      case EnumTipoMensagem.Alerta:
        typeName = 'Atenção';
        break;

      case EnumTipoMensagem.Info:
      case EnumTipoMensagem.Indefinido:
        default:
          typeName = 'Informação';
        break;
    }
    return typeName;

  }



  getClassButtonYes(enumType: EnumTipoMensagem): string {

    let className = '';

    switch (enumType) {

      case EnumTipoMensagem.Sucesso:
        className = 'bt-green';
        break;

      case EnumTipoMensagem.Erro:
        className = 'bt-red';
          break;

      case EnumTipoMensagem.Alerta:
        className = 'bt-orange';
        break;

      case EnumTipoMensagem.Info:
      case EnumTipoMensagem.Indefinido:
        default:
          className = 'bt-blue-light';
        break;

    }

    return  className;
  }

  getClassButtonNo(enumType: EnumTipoMensagem): string {

    let className = 'bt-white';

    if(this.data.isConfirm) {
      return className;
    }

    switch (enumType) {

      case EnumTipoMensagem.Sucesso:
        className = 'bt-green';
        break;

      case EnumTipoMensagem.Erro:
        className = 'bt-red';
          break;

      case EnumTipoMensagem.Alerta:
        className = 'bt-orange';
        break;

      case EnumTipoMensagem.Info:
      case EnumTipoMensagem.Indefinido:
        default:
          className = 'bt-blue-light';
        break;

    }

    return  className;
  }

}


